// extracted by mini-css-extract-plugin
export default {"route__loading-container":"route_route__loading-container__J7fIQ"};